import {Component} from "react";
import * as React from "react";

import {Link} from "react-router-dom";

interface TableCellProps
{
    to?: string;
    enableLink?: boolean;
    className?: string;
    flex?: number;
    onClick?: () => void
}

interface TableCellState
{

}

export default class TableCell extends Component<TableCellProps,TableCellState>
{
    public componentDidMount() {

    }

    public render() {

        const CellComponent = this.props.enableLink ? Link : "div";
        
        const flexClass = this.props.flex ? `flex-item--flex-${this.props.flex}` : "";
        
        return (
            <CellComponent to={this.props.to ? this.props.to : ""} className={`cdb-table__cell ${flexClass} ${this.props.className ? this.props.className : ""}`} onClick={this.props.onClick}>
                {this.props.children}
            </CellComponent>
        );
    }
}